/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";
export const OperadoraCartaoSCH = (perPage) => {
  let filtro = new Filtro();
  filtro.perPage = perPage;
  filtro.fields = ['*'];
  filtro.addOrder('formas_pagamento.nome', 'asc');
  return filtro
};
